import { Flex, ButtonGroup, Checkbox, Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { PanelModal } from '../../common/components/panel-modal';
import { useQueueStore } from '../context/use-queue-store';
import { useAvailableColumns } from '../hooks/use-available-columns';
import { useColumnDisplayNames } from '../hooks/use-column-display-names';

export const QueueColumnSelector = observer(function QueueColumnSelector({
    onClose,
}: {
    onClose: () => void;
}): React.ReactElement | null {
    const store = useQueueStore();
    const columnDisplayNames = useColumnDisplayNames();
    const availableColumns = useAvailableColumns();

    const [selectedColumns, setSelectedColumns] = useState(() =>
        store.workspacePanel.queue.queueColumns.reduce((acc, column) => {
            acc[column.columnDefinition] = true;
            return acc;
        }, {} as Record<string, boolean>)
    );

    return (
        <PanelModal
            onClose={onClose}
            header="Select Columns"
            body={
                <ul
                    style={{ listStyleType: 'none', padding: 0 }}
                    data-testid="queue-column-selector"
                >
                    {availableColumns.map((column) => {
                        return (
                            <li key={column.name} style={{ padding: '0 0 10px 0' }}>
                                <Checkbox
                                    isChecked={!!selectedColumns[column.name]}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setSelectedColumns((value) => ({
                                            ...value,
                                            [column.name]: e?.currentTarget?.checked,
                                        }));
                                    }}
                                >
                                    {columnDisplayNames[column.name].displayName}
                                </Checkbox>
                            </li>
                        );
                    })}
                </ul>
            }
            footer={
                <Flex w="100%" justifyContent="flex-end">
                    <ButtonGroup>
                        <Button variant="ghost" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => {
                                const columnsToDisplay = store.workspacePanel.queue.availableColumns.filter(
                                    (x) => selectedColumns[x.name]
                                );
                                store.workspacePanel.queue.updateColumns(
                                    columnsToDisplay.map((x) => ({
                                        ...x,
                                        columnDefinition: x.name,
                                    }))
                                );
                                onClose();
                            }}
                        >
                            Save
                        </Button>
                    </ButtonGroup>
                </Flex>
            }
        />
    );
});
